<template>
  <dialog ref="dialog" class="llm-budget-modal" aria-labelledby="llm-budget-title" @close="dismiss" @cancel="dismiss" @keydown.esc.prevent="dismiss">
    <h2 id="llm-budget-title">AI allowance reached</h2>
    <p>
      You've reached your {{ notice.limit?.period === 'month' ? 'monthly' : 'daily' }} AI allowance.
      You can keep browsing and searching the library, and AI tools will work again once it resets.
    </p>
    <p v-if="resetLabel" class="llm-budget-reset">Resets {{ resetLabel }}.</p>
    <div class="llm-budget-actions">
      <button type="button" class="vdb-btn-pill" @click="dismiss">Got it</button>
    </div>
  </dialog>
</template>

<script>
import { llmBudgetNotice } from '@/services/llmBudget.js';

export default {
  name: 'LlmBudgetModal',
  data: () => ({ notice: llmBudgetNotice }),
  computed: {
    resetLabel() {
      const date = new Date(this.notice.limit?.resets_at);
      return Number.isNaN(date.getTime()) ? '' : date.toLocaleString();
    },
  },
  watch: {
    'notice.limit'(limit) {
      if (limit && !this.$refs.dialog.open) this.$refs.dialog.showModal();
      else if (!limit && this.$refs.dialog.open) this.$refs.dialog.close();
    },
  },
  mounted() {
    if (this.notice.limit) this.$refs.dialog.showModal();
  },
  methods: {
    dismiss() { this.notice.limit = null; },
  },
};
</script>

<style scoped>
.llm-budget-modal { box-sizing: border-box; margin: auto; width: min(480px, calc(100vw - 40px)); padding: 32px; border: 1px solid var(--cream-500); border-radius: 18px; background: var(--paper); color: var(--ink-800); }
.llm-budget-modal::backdrop { background: rgb(0 0 0 / 45%); }
.llm-budget-modal h2 { font-size: 24px; font-weight: 600; margin-bottom: 16px; }
.llm-budget-modal p { line-height: 1.6; margin-bottom: 16px; }
.llm-budget-reset { font-size: 13px; color: var(--ink-500); }
.llm-budget-actions { display: flex; gap: 12px; flex-wrap: wrap; margin-top: 24px; }
</style>
